(function () {
  'use strict';

  var storageKey = 'shopify-wishlist';
  var savedLimit = 50;

  function readSaved() {
    try {
      return (window.localStorage.getItem(storageKey) || '').split(',').filter(Boolean).slice(0, savedLimit);
    } catch (error) {
      return [];
    }
  }

  function writeSaved(handles) {
    try {
      if (handles.length) window.localStorage.setItem(storageKey, handles.slice(0, savedLimit).join(','));
      else window.localStorage.removeItem(storageKey);
      return true;
    } catch (error) {
      return false;
    }
  }

  function setButtonState(button, isSaved) {
    var title = button.dataset.productTitle || 'product';
    var icon = button.querySelector('[data-tcg-card-save-icon]');
    var label = button.querySelector('[data-tcg-card-save-label]');
    button.classList.toggle('is-saved', isSaved);
    button.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
    button.setAttribute('aria-label', (isSaved ? 'Remove ' : 'Save ') + title);
    button.title = isSaved ? 'Remove from Saved items' : 'Save item';
    if (icon) icon.textContent = isSaved ? '♥' : '♡';
    if (label) label.textContent = isSaved ? 'Saved' : 'Save item';
  }

  function refreshSavedUI() {
    var handles = readSaved();
    document.querySelectorAll('[data-tcg-card-save]').forEach(function (button) {
      setButtonState(button, handles.indexOf(button.dataset.productHandle) !== -1);
    });
    document.querySelectorAll('[data-tcg-saved-count]').forEach(function (node) {
      node.textContent = handles.length;
      node.hidden = handles.length === 0;
    });
  }

  function toggleCardSave(button) {
    var handle = button.dataset.productHandle;
    if (!handle) return;
    var handles = readSaved();
    var index = handles.indexOf(handle);
    if (index === -1) handles.unshift(handle);
    else handles.splice(index, 1);
    if (!writeSaved(handles)) {
      button.disabled = true;
      button.title = 'Saving unavailable';
      return;
    }
    refreshSavedUI();
  }

  document.addEventListener('DOMContentLoaded', function () {
    refreshSavedUI();

    document.addEventListener('click', function (event) {
      var cardButton = event.target.closest('[data-tcg-card-save]');
      if (cardButton) {
        event.preventDefault();
        toggleCardSave(cardButton);
        return;
      }

      if (event.target.closest('[data-tcg-save-product], [data-tcg-remove-saved]')) {
        window.setTimeout(refreshSavedUI, 0);
      }
    });

    new MutationObserver(function (mutations) {
      var hasProductCards = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          return node.nodeType === 1 && (node.matches('[data-tcg-card-save]') || node.querySelector('[data-tcg-card-save]'));
        });
      });
      if (hasProductCards) refreshSavedUI();
    }).observe(document.body, { childList: true, subtree: true });

    window.addEventListener('storage', function (event) {
      if (event.key === storageKey) refreshSavedUI();
    });
  });
})();
